import { useContext } from "react";
import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import TreeForm from "components/agro/trees/TreeForm";
import { createTree } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const TreeCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const tree = {
    name: "",
    companyID: me?.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: createTree.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            companyID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorCreate);
      console.error(err);
    }
  }

  return (
    <div>
      <TreeForm onSubmit={onSubmit} initialValues={tree} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successAdded: "Árbol agregado con éxito",
    responses: {
      errorCreate: "Error al crear árbol",
    },
  },
});

export default TreeCreateForm;
